<template>
    <div id="app">
  	    <keep-alive exclude="home">
	       <router-view></router-view>
	    </keep-alive>
        <router-view v-if="!isRouterAlive"></router-view>
    </div>
</template>
<script>
    export default {
        name: 'app',
        provide (){
            return {
                reload: this.reload
            }
        },
        data () {
            return {
                isRouterAlive: true
            }
        },
        created(){
            this.deleteRepeatTabs();
        },
        methods:{
            reload(){
                this.deleteRepeatTabs();
                this.$nextTick(function(){
                    this.isRouterAlive = true;
                });
                this.isRouterAlive = false;
            },
            deleteRepeatTabs(){
                let obj = {};
                let options = this.$store.state.options.reduce((cur,next) => {
                    obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
                    return cur;
                },[]);
                options.forEach((item,index) =>{
                    this.$store.commit('delete_tabs', item.route);
                })
            }
        }
    }
</script>

<style lang="scss" type="text/css">
    @import './assets/css/base.css';
    @import '../node_modules/iview/dist/styles/iview.css';
    .app-nav-wrap{
        background-color:#3b3b3b
    }
    .el-table th.gutter{
        display: table-cell!important;
    }
    .el-table colgroup.gutter{
        display: table-cell!important;
    }
    .el-pagination__editor.el-input{
            width:70px!important
        }
    .el-menu-item:focus{
        color:#333!important
    }
    .el-dropdown{
        color:#fff;
    }
    .el-tabs__nav-wrap{
        max-width:100%
    }
    .el-menu-item.is-active{
        background-color:#ecf5ff;
        color:#333!important
    }
    .el-tabs--border-card>.el-tabs__header{
        max-width:100%;
        overflow:hidden
    }
    #home .app-content .app-wrap{
        max-width:100%
    }
    .el-pagination__jump .el-input__inner {
        padding: 0 3px;
        width:auto !important
    }
    .el-transfer-panel__list{
        height:160px!important;
    }
    .el-menu{
        background-color:#3b3b3b !important;
        .el-menu-item,.el-submenu{
            color:#fff;
            transition:.1s;
            &:hover{
                color:#333
            }
        .el-submenu__title{
                transition:.1s;
                color:#fff;
                &:hover{
                    color:#333
                }
            }
        }
    }
    .el-table__header tr,.el-table__header th {
        padding: 5px 0;
        height: 40px;
    }
    .el-table__body tr,.el-table__body td {
        padding: 5px 0;
        height: 40px;
    }
    .mod-sys__log-error-view-info {
      width: 80%;
    }
</style>



// WEBPACK FOOTER //
// App.vue?25ee1e3a